import {
  createFileRoute,
  Outlet,
  useRouterState,
} from '@tanstack/react-router';

import CompleteProfileModal from '@/components/ProfileCompletion';
import { useAuth } from '@/hooks/use-auth';
import { requireAuth } from '@/lib/router/route-guards';

export const Route = createFileRoute('/_protected')({
  beforeLoad: ({ context }) => {
    requireAuth(context, '/login');
  },
  component: ProtectedLayoutRoute,
});

function ProtectedLayoutRoute() {
  const { user } = useAuth();
  const { location } = useRouterState();

  const isProfileIncomplete =
    user && (!user.firstName?.trim() || !user.lastName?.trim());

  // Don't show modal on settings page so users can complete their profile
  const isOnSettingsPage = location.pathname.includes('/settings');

  return (
    <>
      <Outlet />
      {isProfileIncomplete && !isOnSettingsPage && <CompleteProfileModal />}
    </>
  );
}
